import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=a80f6c24&scoped=true"
import script from "./ShoppingList.vue?vue&type=script&lang=ts"
export * from "./ShoppingList.vue?vue&type=script&lang=ts"
import style0 from "./ShoppingList.vue?vue&type=style&index=0&id=a80f6c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80f6c24",
  null
  
)

export default component.exports
import {QIcon,QCard,QCardSection,QImg,Ripple} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QIcon,QCard,QCardSection,QImg})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {Ripple})
